import { TeaBlocksError } from './../../../TeaBlocksError';
import { ReturnBlock } from "../../ReturnBlock";


/**
 * Math modulo block. Performs inputs[0]%inputs[1]%inputs[2]...
 */
export class ModuloBlock extends ReturnBlock {
    inputs;

    /**
     * Constructor
     * @param inputs the operands
     */
    constructor(id: string, inputs: ReturnBlock[]) {
        super(id)
        this.inputs = inputs;
    }

    /**
     * Evaluates the expression
     * @param varEnv variable environment
     */
    evalBlock(varEnv: Map<string, any>): number {
        let num = Number(this.inputs[0].evalBlock(varEnv));

        if (this.inputs.length === 1) return num;
        if (isNaN(num)) throw new TeaBlocksError('Inputs Must be Number', this.id);

        this.inputs.slice(1).forEach(inp => {
            let val = Number(inp.evalBlock(varEnv));
            if (isNaN(val)) throw new TeaBlocksError('Inputs must be numbers', this.id);
            num %= val;
        })

        return num;
    }
}
